import React, { useEffect } from 'react';
import { Box, Paper, CircularProgress } from '@mui/material';
// Backdrop 
import { useState, Downgraded, } from '@hookstate/core';
// import Title from '../../sharedcomponents/title/title';
import DataList from './dataList/dataList';
import { FULL_PERMISSION } from '../../constants/Constant';
import AddNotification from './addNotification';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import { useEventState } from '../../stores/eventStore';
import Helper from '../../utility/helper';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import UserListDialog from './userListDialog';
// import CircularProgressWithLabel  from '../../sharedcomponents/crcularProgressWithLabel'
const NotificationList = (props) =>
{
    const loading = useState(false);
    const openNotification = useState(false);
    const editNotificationInfo = useState()
    const [modPermission, setModPermission] = React.useState(null);
    const eventState = useEventState();
    const allData = useState([]);
    const eventData = useState(null);
    const userData = useState(null)
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const isView = useState(false);
    const currentNotification = useState({});
    const overallParticipants = useState([]);
    const filteredParticipants = useState([]);
    const openAddParticipantDialog = useState(false);
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const sendConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const [progress, setProgress] = React.useState(0);
    const [showCustomLoaderForEmail, setshowCustomLoaderForEmail] = React.useState(false);
    const [customNotificationID, setCustomNotificationID] = React.useState(0);

    // const [openBackdrop, setBackDrop] = React.useState(false);
    const [sendNotificationData, setSendNotificationData] = React.useState(null)
    useEffect(() =>
    {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState && eventState.eventDetail.get())
        {
            if (Helper.isAdminUser(userInfo))
            {
                setModPermission(FULL_PERMISSION);
            }
             else if (userInfo.roles && Helper.isEventAdmin(userInfo))
            {
                // const permissions = eventState.permissions
                //     .attach(Downgraded)
                //     .get();
                // if (permissions && permissions.length > 0)
                // {
                //     setModPermission(
                //         Helper.getModuleAccessPermission(permissions, 'HOTEL')
                //     );
                // }
                setModPermission(FULL_PERMISSION);
            }
        }

    }, [eventState]);
    useEffect(() =>
    {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        if (
            (eventData.get() == null ||
                (eventData.get() &&
                    eventData.eventID.value != eventInfo.eventID))
        )
        {
            eventData.set(eventInfo);
            userData.set(userInfo)
        }

        ApiHelper.get(APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(eventData.get().eventID))
            .then(res =>
            {
                let participantData = [];
                res.data.rows.map((item) =>
                {
                    participantData.push({ ...item, selected: false })

                })
                overallParticipants.set(participantData);

            })

    }, [])

    useEffect(() =>
    {
        getNotification();
    }, [])
    const getNotification = () =>
    {
        loading.set(true);
        let participantList = [];
        let activityData = []
        ApiHelper.get(APIURLConstants.GET_NOTIFICATION(eventData.get().eventID)).then(res =>
        {
            let allNotification;

            if (res.data.length > 0)
            {

                allNotification = res

                res.data.map((item) =>
                {
                    if (item.notificationStatus === 1)
                    {

                        item.participants.map((user) =>
                        {
                            if (
                                participantList.indexOf(user.participants) == -1
                            )
                            {
                                participantList.push(user.participants);
                            }
                        })

                        activityData.push({
                            actualData: item,
                            row: [
                                {
                                    label: 'checkbox',
                                    key: 'notificationId',
                                    notificationID: item.notificationID,
                                    width: '0.03',
                                    inColumn: true,
                                    alignCenter: true,
                                },
                                {
                                    label: 'Action',
                                    key: 'Notification',
                                    Notification: 'Notification',
                                    width: '0.02',
                                    inColumn: true,
                                    alignCenter: true,
                                    isOpened: item.notificationStatus
                                },
                                {
                                    label: 'Name',
                                    key: 'message',
                                    message: item.notificationText,
                                    showLabel: false,
                                    width: '0.30',
                                    inColumn: true,
                                    showDetails: true,
                                    createdDate:
                                        Helper.FormatDate(
                                            item.createdDate
                                        ) +
                                        ' @ ' +
                                        Helper.FormatTime(
                                            item.createdDate
                                        ),
                                    createdBy: item.createdByName
                                },

                                {
                                    label: 'checkboxEmail',
                                    key: 'type',
                                    type: item.type,
                                    width: '0.10',
                                    inColumn: true,
                                },
                                {
                                    label: 'checkboxPush',
                                    key: 'type',
                                    type: item.type,
                                    width: '0.10',
                                    inColumn: true,
                                },
                                {
                                    label: 'checkboxConnection',
                                    key: 'includeConnections',
                                    includeConnections: item.includeConnections,
                                    width: '0.20',
                                },
                                {
                                    label: 'Status',
                                    key: 'status',
                                    status:
                                        item.notificationStatus == 2 ? 'Sent ' +
                                            ' On ' +
                                            Helper.FormatDate(
                                                item.sendDate
                                            ) +
                                            ' @ ' +
                                            Helper.FormatTime(
                                                item.sendDate
                                            ) : 'Unsent',
                                    width: '0.27',
                                    inColumn: true,
                                    isSent: true
                                },

                                {
                                    label: 'Action',
                                    key: 'addParticipants',
                                    addParticipants: 'Add Participants',
                                    width: '0.02',
                                    inColumn: true,
                                    alignCenter: true
                                },
                                {
                                    label: 'Action',
                                    key: 'participants',
                                    participants: 'Participants',
                                    count: item.participants != null ? item.participants.length : 0,
                                    width: '0.02',
                                    inColumn: true,
                                },
                                // {
                                //     label: 'Action',
                                //     key: 'Archive',
                                //     Archive: "Archive",
                                //     width: '0.05',
                                //     inColumn: true,
                                // },
                                {
                                    label: 'Action',
                                    key: 'sendEmail',
                                    sendEmail: 'Send Email',
                                    width: '0.02',
                                },
                                {
                                    label: 'Action',
                                    key: 'edit',
                                    edit: 'Edit',
                                    width: '0.02',
                                    inColumn: true,

                                },
                            ],
                            selected: false,
                            emailSelected: item.type,
                            pushSelected: item.type,
                            includeConnectionSelected: item.includeConnections
                        });
                    }
                })
            }
            else
            {
                activityData = [];
            }
            props.getSentData(allNotification)

            loading.set(false)
        }).catch(err =>
        {
            console.log(err);
            loading.set(false)
            props.getSentData(null)

        })

        allData.set(activityData)


    }
    const redirectToCreate = () =>
    {
        openNotification.set(true);
    }

    const editNotification = (item) =>
    {
        editNotificationInfo.set(item.actualData)
        openNotification.set(true);
    }
    const handleClose = () =>
    {
        openNotification.set(false);
        editNotificationInfo.set(null)
    }
    const deleteNotification = () =>
    {
        const selected = allData
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0)
        {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select Notifications first',
            });
        } else
        {
            let message =
                selected.length == allData.get().length
                    ? 'Do you want to delete all Notifications ?'
                    : 'Do you want to delete selected Notifications ?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    }

    const handleConfirmation = () =>
    {
        let deleteNotification = [];
        allData.get().map((notification) =>
        {
            if (notification.selected === true)
            {
                deleteNotification.push(notification.actualData.notificationID);
            }
        });
        ApiHelper.post(APIURLConstants.DELETE_NOTIFICATION_LIST, {
            eventID: eventData.get().eventID,
            ids: deleteNotification,
            modifiedBy: userData.get().userID
        }).then(res =>
        {
            if (res.data)
            {
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'success',
                    message: 'Request deleted successfully',
                });
                getNotification();
            }
        }).catch(error =>
        {
            let message = '';
            if (error.response && error.response.status === 401)
            {
                message = 'Access denied';
            } else
            {
                message = 'Error while deleting request';
            }
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: message,
            });
        })
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    }

    const sendEmailNotification = (item) =>
    {
        if (item.actualData.participants.length === 0)
        {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please add at least one participant',
            });
        }
        else
        {
            let message = 'Do you want to send notification to user'
            sendConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
            setSendNotificationData(item)

        }
    };

    // const sendConfirmationNotification = () =>
    // {
    //     let item = sendNotificationData
    //     let filteredParticipants=item.actualData.participants.filter((elem) => {
    //         return overallParticipants.attach(Downgraded).get().some((ele) => {
    //         return ele.userID === elem.userID && ele.isPublished;
    //           })})
    //     const percentageValue = Math.round(100 /filteredParticipants.length);
    //     if (filteredParticipants.length>0)
    //     {
    //         sendConfirmation.set({
    //             open: false,
    //             title: '',
    //             OkButtonText: 'Ok',
    //             message: '',
    //         });
    //         // setBackDrop(true);
    //         setshowCustomLoaderForEmail(true)
    //         setCustomNotificationID(item.actualData.notificationID)
    //         let resLength = [];
    //         Promise.all(
    //             filteredParticipants.map(async (value) =>
    //             {
    //                 const userInfo = Helper.getStorage('userInfo');
    //                 const response = await ApiHelper.post(
    //                     APIURLConstants.POST_SEND_NOTIFICATION, {
    //                     NotificationID: item.actualData.notificationID,
    //                     IncludeConnections: item.includeConnectionSelected,
    //                     Type: item.actualData.type,
    //                     EventName: eventData.get().eventName,
    //                     ModifiedBy: userInfo.userID,
    //                     UserID: value.userID
    //                 })
    //                 if(item.pushSelected===true){
    //                 ApiHelper.get(
    //                     APIURLConstants.GET_PUSH_NOTIFICATION(
    //                         value.userID,
    //                         eventData.get().eventID,
    //                         eventData.get().eventName
    //                     )
    //                 ).then((res) =>
    //                 {
    //                     console.log(res);
    //                 });
    //             }
    //                 const jsonResponse = await response;
    //                 resLength.push(jsonResponse);
    //                 setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + percentageValue));
    //                 if (resLength.length === filteredParticipants.length)
    //                 {
    //                     setshowCustomLoaderForEmail(false)
    //                     setProgress(0)
    //                     setSnackBarProps({
    //                         ...snackBarProps,
    //                         openSnack: true,
    //                         variant: 'success',
    //                         message: 'Email Sent successfully',
    //                     });
    //                     setSendNotificationData(null)
    //                     getNotification();
    //                 }
    //             })
    //         ).catch(function (err)
    //         {
    //             setSnackBarProps({
    //                 snackBarProps,
    //                 openSnack: true,
    //                 variant: 'error',
    //                 message: 'Please try after some time.'
    //             })
    //             console.log(err);
    //             setSendNotificationData(null)
    //         });
    //     }
    //     else{
    //         setSnackBarProps({
    //             snackBarProps,
    //             openSnack: true,
    //             variant: 'error',
    //             message: 'Event is unpublished for this Participant.'
    //         }) 
    //     }
    // }
    const sendConfirmationNotification = () =>
    {
        let item = sendNotificationData
        let filteredParticipants=item.actualData.participants.filter((elem) => {
            return overallParticipants.attach(Downgraded).get().some((ele) => {
            return ele.userID === elem.userID && ele.isPublished;
              })})
        //const percentageValue = Math.round(100 /filteredParticipants.length);
        if (filteredParticipants.length>0)
        {
            sendConfirmation.set({
                open: false,
                title: '',
                OkButtonText: 'Ok',
                message: '',
            });
            // setBackDrop(true);
            setshowCustomLoaderForEmail(true)
            setCustomNotificationID(item.actualData.notificationID)
            //let resLength = [];
            let UserIDs = [];
            filteredParticipants.map((value) =>
            {
                UserIDs.push(value.userID)
            });
            
            const userInfo = Helper.getStorage('userInfo');
                    ApiHelper.post(APIURLConstants.POST_SEND_NOTIFICATION, {
                        NotificationID: item.actualData.notificationID,
                        IncludeConnections: item.includeConnectionSelected,
                        Type: item.actualData.type,
                        EventName: eventData.get().eventName,
                        ModifiedBy: userInfo.userID,
                        EventID: eventData.get().eventID,
                        UserID: UserIDs.toString(),
                    })
                        .then((res) => {
                            setshowCustomLoaderForEmail(false);
                            setProgress(0);
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: true,
                                variant: 'success',
                                message: 'Email Sent successfully',
                            });
                            setSendNotificationData(null);
                            getNotification();
                        })
                        .catch((error) => {
                            console.log('error : ', error);
                            setshowCustomLoaderForEmail(false);
                            setSnackBarProps({
                                snackBarProps,
                                openSnack: true,
                                variant: 'success',
                                message: 'Once All The Notifications are sent. You will get notification',
                            });
                            setSendNotificationData(null);
                            getNotification();
                        }); 

        }                  
            
    }
    const handleAddParticipants = (notification) =>
    {
        currentNotification.set(notification)
        getNotificationParticipants(notification.actualData.notificationID)
            .then(participants =>
            {
                let ids = participants.map(x => x.userID);
                let allParticipants = overallParticipants.attach(Downgraded).get()
                let userList = allParticipants.filter(x => !ids.includes(x.userID))
                filteredParticipants.set(userList)

                openAddParticipantDialog.set(true);
            }).catch(err =>
            {
                console.log(err);
                setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
            })

    }

    function getNotificationParticipants(id)
    {
        return ApiHelper.get(APIURLConstants.GET_NOTIFICATION_PARTICIPANTS(id))
            .then(participants =>
            {
                return participants.data;
            })
            .catch(err =>
            {
                console.log(err);
            });
    }
    const addParticipants = (selectedUsers) =>
    {
        if (selectedUsers.length === 0)
        {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants first',
            });
        } else
        {
            let notification = currentNotification.attach(Downgraded).get();
            let obj = {
                notificationID: notification.actualData.notificationID,
                createdBy: userData.attach(Downgraded).get().userID,
                participants: selectedUsers
            }
            ApiHelper.post(APIURLConstants.POST_NOTIFICATION_PARTICIPANTS, obj).then(res =>
            {
                if (res)
                {
                    setSnackBarProps({ openSnack: true, variant: 'success', message: 'Participants added successfully.' });
                    openAddParticipantDialog.set(false);
                    getNotification()

                } else
                {

                    setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
                }

            })
                .catch(err =>
                {
                    console.log(err);

                    setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
                })
        }
    }
    const handleViewParticipants = (notification) =>
    {
        currentNotification.set(notification)
        isView.set(true)
        ApiHelper.get(APIURLConstants.GET_NOTIFICATION_PARTICIPANTS(notification.actualData.notificationID))
            .then(participants =>
            {
                let ids = participants.data.map(x => x.userID);
                let allParticipants = overallParticipants.attach(Downgraded).get()
                let userList = allParticipants.filter(x => ids.includes(x.userID))
                filteredParticipants.set(userList)
                openAddParticipantDialog.set(true);
            }).catch(err =>
            {
                console.log(err);
                setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
            })
    }

    const handleCloseAddParticipant = () =>
    {
        openAddParticipantDialog.set(false);
        isView.set(false);
    }
    const deleteParticipants = (selectedUsers) =>
    {
        if (selectedUsers.length === 0)
        {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants first',
            });
        } else
        {
            const userInfo = Helper.getStorage('userInfo');
            let notification = currentNotification.attach(Downgraded).get();
            let obj = { eventID: eventData.get().eventID, notificationID: notification.actualData.notificationID, modifiedBy: userInfo.userID, Ids: selectedUsers }
            deleteNotificationParticipants(obj)
                .then(res =>
                {
                    if (res)
                    {
                        setSnackBarProps({ openSnack: true, variant: 'success', message: 'Participants deleted successfully.' });
                        getNotification();
                        openAddParticipantDialog.set(false);
                        isView.set(false);
                    } else
                    {

                        setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
                    }

                })
                .catch(err =>
                {
                    console.log(err);

                    setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
                })
        }
    }

    function deleteNotificationParticipants(obj)
    {
        return ApiHelper.post(APIURLConstants.DELETE_NOTIFICATION_PARTICIPANTS, obj)
            .then(result =>
            {
                return result.data;
            })
            .catch(err =>
            {
                console.log(err);
            });
    }
    const mailSelect = (checked, item) =>
    {
        if (checked === true)
        {
            ApiHelper.post(APIURLConstants.UPDATE_NOTIFICATION, {
                eventID: eventData.get().eventID,
                notificationID: item.actualData.notificationID,
                modifiedBy: userData.get().userID,
                status: null,
                type: 1,
                includeConnections: null
            }).then(res =>
            {
                console.log(res.data);

            });
        }
        if (checked === false)
        {
            ApiHelper.post(APIURLConstants.UPDATE_NOTIFICATION, {
                eventID: eventData.get().eventID,
                notificationID: item.actualData.notificationID,
                modifiedBy: userData.get().userID,
                status: null,
                type: 0,
                includeConnections: null
            }).then(res =>
            {
                console.log(res.data);

            });
        }

    }

    const includeConnectionSelect = (checked, item) =>
    {
        if (checked === true)
        {
            ApiHelper.post(APIURLConstants.UPDATE_NOTIFICATION, {
                eventID: eventData.get().eventID,
                notificationID: item.actualData.notificationID,
                modifiedBy: userData.get().userID,
                status: null,
                type: null,
                includeConnections: 1
            }).then(res =>
            {
                console.log(res.data);

            });
        }
        if (checked === false)
        {
            ApiHelper.post(APIURLConstants.UPDATE_NOTIFICATION, {
                eventID: eventData.get().eventID,
                notificationID: item.actualData.notificationID,
                modifiedBy: userData.get().userID,
                status: null,
                type: null,
                includeConnections: 0
            }).then(res =>
            {
                console.log(res.data);

            });
        }

    }
    return (
        <Box sx={{ width: '100%' }}>
            {(loading.get() || showCustomLoaderForEmail) ?  (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                        marginTop: '15%'
                    }}>
                    <CircularProgress />

                </Box>
            ) : (
                <Box>

                    <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none',backgroundColor:'unset' }}>
                        <DataList
                            showSearch={true}
                            data={allData.attach(Downgraded).get()}
                            title={''}
                            handleClick={redirectToCreate}
                            buttonTitle={'Add'}
                            mailSelect={mailSelect}
                            includeConnectionSelect={includeConnectionSelect}
                            modPermission={modPermission}
                            searchLabel={'Search'}
                            deleteRows={deleteNotification}
                            editRow={editNotification}
                            sendEmailNotification={sendEmailNotification}
                            handleAddParticipants={handleAddParticipants}
                            handleViewParticipants={handleViewParticipants}
                            customLoaderForEmail={showCustomLoaderForEmail}
                            progressValue={progress}
                            customNotificationID={customNotificationID}
                        />
                    </Paper>
                    {openNotification.get() && <AddNotification
                        notificationInfo={editNotificationInfo
                            .attach(Downgraded)
                            .get()}
                        title="Custom Notification"
                        open={openNotification.get()}
                        handleClose={handleClose}
                        getNotification={getNotification}
                        setSnackBarProps={setSnackBarProps}
                    />}
                </Box>
            )
            }
            {openAddParticipantDialog.get() && (
                <UserListDialog
                    title={!isView.get() ? "ADD PARTICIPANTS" : "VIEW PARTICIPANTS"}
                    addParticipants={addParticipants}
                    open={openAddParticipantDialog.get()}
                    deleteParticipants={deleteParticipants}
                    handleClose={handleCloseAddParticipant}
                    users={filteredParticipants.attach(Downgraded).get()}
                    isView={isView.get()}
                    selectAllCheckBox={true}
                />
            )}
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() =>
                    {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={sendConfirmation.get().open}
                    message={sendConfirmation.get().message}
                    OkButtonText={sendConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        sendConfirmationNotification()
                    }
                    onCancelClick={() =>
                    {
                        sendConfirmation.set({
                            ...sendConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }

            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {/* <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openBackdrop}
            >
                {/* <CircularProgress color="inherit" /> */}
            {/*  <CircularProgressWithLabel value={progress} />;
            </Backdrop> */}
        </Box>

    )
}

export default NotificationList